// Contracts — дневная статистика дизайн-плагина для менеджеров (issue #582).
// GET /api/work/manager/pluginDailyStats?from=YYYY-MM-DD&to=YYYY-MM-DD —
// «сколько сегодня сделал дизайнер X», по дням и по людям, окно ≤ 31 день
// (недельная витрина листается клиентом). Смотрят из internal.weern.com →
// pothos-manager; гейт — requireWorkManager (WORK_MANAGER_EMAILS / pothos
// team_role='manager'), как у остальных /manager/* ручек.
//
// Метрики сняты с реальных таблиц конвейера (не придуманы):
//   masters_saved / masters_ready — des_master_specs (версии мастера из
//     плагина; ready=1 — «готово к размножению», фиксация карты полей);
//   frames_submitted — des_deliverables по дню ПЕРВОЙ сдачи (created_at:
//     реворк перезаливает ту же строку и второй раз день не засчитывает);
//   frames_indexed / frames_rejected — текущая судьба сданных В ТОТ день
//     кадров (доехал до каталога / отклонён QA) — качество, не объём;
//   ship_frames — кадры размножения, отгруженные dev-плагином
//     (dev_ship_frames × dev_ship_batches.opened_by).
// День — календарный UTC (substr(created_at,1,10)), как везде в воркере.
import { z } from 'zod';

const dayStr = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

// Query. Порядок/длину окна проверяет хендлер (dayRange): zod видит только
// форму даты, «to раньше from» и «32 дня» — доменные 400 bad_range.
export const WorkManagerPluginDailyStatsQuerySchema = z.object({
  from: dayStr,
  to: dayStr,
});
export type WorkManagerPluginDailyStatsQuery = z.infer<typeof WorkManagerPluginDailyStatsQuerySchema>;

// Один набор счётчиков — и на человека, и на итог дня.
const metricFields = {
  masters_saved: z.number().int().nonnegative(),
  masters_ready: z.number().int().nonnegative(),
  frames_submitted: z.number().int().nonnegative(),
  frames_indexed: z.number().int().nonnegative(),
  frames_rejected: z.number().int().nonnegative(),
  ship_frames: z.number().int().nonnegative(),
};

export const WorkPluginDailyMetricsSchema = z.object(metricFields);
export type WorkPluginDailyMetrics = z.infer<typeof WorkPluginDailyMetricsSchema>;

export const WorkPluginDailyPersonSchema = z.object({
  // Почта — единый ключ человека во всех трёх источниках (author_email /
  // photographers.email через uploaded_by / opened_by). '' не бывает — пустая
  // сторона схлопывается в 'unknown', чтобы строка не выглядела дырой в UI.
  email: z.string(),
  name: z.string(),          // display_name из photographers; '' если не нашли
  ...metricFields,
});
export type WorkPluginDailyPerson = z.infer<typeof WorkPluginDailyPersonSchema>;

export const WorkPluginDailyDaySchema = z.object({
  day: dayStr,
  people: z.array(WorkPluginDailyPersonSchema),   // отсортированы по объёму
  totals: WorkPluginDailyMetricsSchema,
});
export type WorkPluginDailyDay = z.infer<typeof WorkPluginDailyDaySchema>;

export const WorkManagerPluginDailyStatsResSchema = z.object({
  from: dayStr,
  to: dayStr,
  // ВСЕ дни окна, включая пустые (people: [], totals: нули) — витрина листает
  // по дням, и «день без строк» обязан выглядеть нулём, а не отсутствием.
  // Новые дни первыми.
  days: z.array(WorkPluginDailyDaySchema),
});
export type WorkManagerPluginDailyStatsRes = z.infer<typeof WorkManagerPluginDailyStatsResSchema>;
